import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import api from "@/lib/api";
import { Reveal, WindReveal } from "@/components/Cinematic";

export default function Services() {
  const [services, setServices] = useState([]);
  useEffect(() => {
    document.title = "Services — seedesign";
    api.get("/services").then((r) => setServices(r.data)).catch(() => {});
  }, []);

  return (
    <div className="pt-28 pb-24">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
        <p className="text-sm uppercase tracking-[0.2em] text-[#66371B] mb-4">Services</p>
        <h1 className="font-serif text-5xl sm:text-6xl lg:text-7xl tracking-tight text-[#3F3F2C] max-w-4xl">
          <WindReveal text="The ways we build brands worth remembering." />
        </h1>
        <p className="mt-6 max-w-2xl text-lg text-[#3F3F2C]">
          From strategy to shelf — engaged individually or as a full creative direction partnership.
        </p>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="services-grid">
          {services.map((s, i) => (
            <Reveal key={s.slug} delay={(i % 3) * 0.06}>
              <Link to={`/services/${s.slug}`} data-testid={`service-card-${s.slug}`}
                className="group flex h-full flex-col justify-between rounded-sm border border-[#E3D8C1] bg-[#F7F1E1] p-8 outline-none focus:outline-none focus-visible:border-[#66371B] hover:border-[#66371B] hover:-translate-y-1 transition-all">
                <div>
                  <span className="text-sm text-[#81754B]">{String(i + 1).padStart(2, "0")}</span>
                  <h3 className="font-serif text-2xl lg:text-3xl text-[#3F3F2C] mt-2 group-hover:text-[#66371B] transition-colors">{s.title}</h3>
                  <p className="signature text-lg text-[#81754B] mt-1">{s.tagline}</p>
                  <p className="text-sm text-[#3F3F2C] mt-4 leading-relaxed">{s.description}</p>
                </div>
                <span className="mt-6 inline-flex items-center gap-2 text-sm uppercase tracking-[0.15em] text-[#66371B]">
                  Explore <ArrowUpRight size={16} className="group-hover:rotate-45 transition-transform" />
                </span>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  );
}
